import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import * as _ from 'lodash'

import { BLUE, GRAY, LIGHTER_GRAY } from '../styles'
import { getTemplateInfo } from '../../templates/templates'
import shopifyImage from '../../assets/shopify.jpg'
import * as integrationType from '../../constants/integrationType'

const IntegrationsContainer = styled.div`
  display: flex;
  align-items: center;
`
const IntegrationButton = styled.div`
  padding: 0 15px;
  margin: 15px 25px 15px 0px;
  width: 110px;
  height: 110px;
  border: ${props => props.active ? 3 : 2}px solid ${props => props.active ? BLUE : LIGHTER_GRAY};
  border-radius: 10px;
  background: url('${props => props.image}') no-repeat;
  background-size: 75% auto;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`
const IntegrationButtonLabel = styled.div`
  text-align: center;
  font-size: 14px;
  color: ${GRAY};
`

class IntegrationsButtons extends Component {

  getIntegrationImage (iType) {
    switch (iType) {
      case integrationType.SHOPIFY:
        return shopifyImage
      default:
        return null
    }
  }

  onSelectIntegration = (iType) => {
    return () => {
      this.props.onSelectIntegration(iType)
    }
  }

  render () {
    const { templateId, selectedIntegration } = this.props
    if (templateId) {
      const integrations = getTemplateInfo(templateId).integrations
      return (
        <IntegrationsContainer>
          {_.map(integrations, iType => {
            return (
              <IntegrationButton
                key={iType}
                active={selectedIntegration === iType}
                image={this.getIntegrationImage(iType)}
                onClick={this.onSelectIntegration(iType)}
              />
            )
          })}
          <IntegrationButton
            active={selectedIntegration === null}
            onClick={this.onSelectIntegration(null)}
          >
            <IntegrationButtonLabel>No Integration</IntegrationButtonLabel>
          </IntegrationButton>
        </IntegrationsContainer>
      )
    }
  }
}

IntegrationsButtons.propTypes = {
  templateId: PropTypes.string.isRequired, // eslint-disable-line react/no-unused-prop-types
  selectedIntegration: PropTypes.string,
  onSelectIntegration: PropTypes.func.isRequired,
}

export default IntegrationsButtons



// WEBPACK FOOTER //
// ./src/components/integrations/IntegrationsButtons.js